import { DeviceListResponse } from "../../models/device";
import { ReactComponent as ForwardIcon } from "../../assets/Forward.svg";
import "./CustomerDetailDevices.css";
import { DeviceStateChip } from "../../app/lifts/details/DeviceStateChip";

export interface CustomerDetailDevicesProps {
  devices: DeviceListResponse[];
  onItemSelected: (index: number) => void;
}

export const CustomerDetailDevices = ({
  devices,
  onItemSelected,
}: CustomerDetailDevicesProps) => {
  const onItemClicked = (e: React.MouseEvent, index: number) => {
    e.preventDefault();
    onItemSelected(index);
  };

  return (
    <div className="customer-detail-devices">
      {devices.map((device, i) => (
        <div
          key={i}
          className="customer-detail-devices-item"
          onClick={(e) => onItemClicked(e, i)}
        >
          <div className="customer-detail-devices-item-area">
            <div className="customer-detail-devices-item-content">
              <header>
                <h3>{device.nickname}</h3>
                <h4>{device.serialNumber}</h4>
              </header>
              <div className="customer-detail-devices-item-status">
                <DeviceStateChip
                  subscriptionState={device.subscriptionState ?? ""}
                />
              </div>
            </div>
            <div className="customer-detail-devices-item-btn">
              <ForwardIcon />
            </div>
          </div>
          <div className="customer-detail-devices-item-line" />
        </div>
      ))}
    </div>
  );
};
